import HttpResponse from "../../../../../utils/http/http.response";

export enum CargoCompanyAddressListResponseItemCargoAddressType {
  HOTEL = "HOTEL",
  STATION = "STATION",
  MEETING_POINT = "MEETING_POINT",
}

export type CargoCompanyAddressListResponseItem = {
  id: string;
  cargoAddressType: CargoCompanyAddressListResponseItemCargoAddressType;
  lat: number;
  lon: number;
  displayName: string;
  town?: string;
  zipCode?: string;
  street?: string;
  houseNo?: string;
  apartment?: string;
  country?: string;
  description?: string;
};

type CargoCompanyAddressListResponse = HttpResponse<
  CargoCompanyAddressListResponseItem[]
>;

export default CargoCompanyAddressListResponse;
